/* WorkTriggerTargetsReadonlyTabRenderer.js */

"use strict";
const _ = require("lodash");
const AdvancedFilter = require("@gluenetworks/entity_grid_gl").AdvancedFilter;
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
//const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class WorkTriggerTargetsReadonlyTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("worktrig-targets-readonly-view-tab-gl");
        this._rootElem.component = this._model;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        if (this._rootElem.hasChildNodes()) {
            this._renderBackButton();
            this._model.gameEditor._titleCmpnt.setTitle("Targets");
            this._model.gameEditor.showViewAction("BackToDetails");
            return Promise.resolve();
        }

        return this._renderBackButton()
            .then(() => this._renderGrid())
            .then(() => {
                this._registerListeners();
                this._model.gameEditor._titleCmpnt.setTitle("Targets");
                this._model.gameEditor.showViewAction("BackToDetails");
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._selectedTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderBackButton() {
        const model = this._model;

        const bcs = [
            {
                content: backButton,
                left: {
                    arrow: {
                        direction: "left",
                    },
                },
            },
        ];
        this._model.gameEditor.setBreadCrumbs(bcs);

        return Promise.resolve();

        function backButton() {
            const el = document.createElement("span");
            el.innerHTML = "Details";
            el.addEventListener("click", () => {
                // clear breadcrumbs link
                model.gameEditor._titleCmpnt.setTitle("Details");
                model.gameEditor.hideViewAction("BackToDetails");
                model.gameEditor.setBreadCrumbs([]);
                // change tab back to general
                model.workTriggerDetailsView.setEditorMode("general");
            });
            // prettier-ignore
            this.renderer = { //jshint ignore:line
                rootElement: el
            };
        }
    }

    async _renderGrid() {
        if (!this._mainContainer) {
            this._mainContainer = document.createElement("main-container");
            if (this._model._method !== "query") {
                this._model._workTriggerDetailsView._renderer._rootElem.classList.add("devices");
                this._mainContainer.classList.add("devices");
            }
            this._rootElem.appendChild(this._mainContainer);
        }

        if (this._model._method === "query") {
            await this._model.retrieveCustomFieldsEntity();
            const customFieldsList = [];
            for (let field in this._model._customFieldsWithInherited) {
                if (
                    this._model._customFieldsWithInherited.hasOwnProperty(field) &&
                    !this._model._customFieldsWithInherited[field].systemOwned &&
                    ["Boolean", "String", "Enum", "Dropdown", "Number"].indexOf(
                        this._model._customFieldsWithInherited[field].dataType
                    ) >= 0
                ) {
                    customFieldsList.push(
                        Object.assign({}, this._model._customFieldsWithInherited[field], {
                            id: field,
                            name: `customFieldValues.${field}`,
                            label: this._model._customFieldsWithInherited[field].name,
                        })
                    );
                }
            }

            let enabledNodeProps = Object.entries(this._model._nodeProps).map(([id, props]) => {
                id = id.replace(/[\t\n\r ]+/g, " ");
                let prop = Object.assign(props);
                prop = Object.assign(prop, {
                    id: `nodeProps.${id}`,
                    name: `nodeProps.${id}`,
                    label: id,
                    path: `nodeProps.${id}`,
                    dataType: props.type || "string",
                });
                if (props.type === "enum") {
                    prop.options = {};
                    props.values.forEach((val) =>
                        Object.assign(prop.options, {[val]: {name: val, title: val}})
                    );
                }
                return {[`nodeProps.${id}`]: prop};
            });

            _.assign(this._model.columnConfigFilter, ...enabledNodeProps);

            this._filterContainer = document.createElement("filter-container");
            this._advancedFilterReadOnly = new AdvancedFilter({
                filterData: this._model._filter,
                columnsConfig: this._getFilterOptions(
                    this._model.columnConfigFilter,
                    customFieldsList
                ),
                allowGroups: true,
            });

            const disabledLayer = document.createElement("div");
            disabledLayer.classList.add("disabled-layer");
            this._advancedFilterReadOnly._renderer._rootElem.prepend(disabledLayer);
            this._filterContainer.appendChild(this._advancedFilterReadOnly._renderer._rootElem);
            this._mainContainer.appendChild(this._filterContainer);
        }

        if (!this._gridContainer) {
            this._gridContainer = document.createElement("grid-container");
            this._mainContainer.appendChild(this._gridContainer);

            if (this._model._method === "query") {
                this._gridTitle = document.createElement("div");
                this._gridTitle.classList.add("title-section");

                this._gridContainer.appendChild(this._gridTitle);
                this._gridTitle.innerHTML = "Filtered Devices";
            }
        }

        if (this._selectedTargetsGrid) {
            this._gridContainer.removeChild(this._selectedTargetsGrid.renderer.rootElement);
            this._selectedTargetsGrid.shutdown();
        }

        this._selectedTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.columnConfig,
            pagingFeed: this._model.pagingFeed,
            showHeader: true,
            gridKey: `${this.model._gridKey}_selected`,
            showLinesNumber:
                this._model._method === "query"
                    ? true
                    : this._model._gameEditor.renderer._rootElem.querySelector(
                          "game-editor-view-actions-gl left-container"
                      ),
            useUserDataStorage: false,
        });
        this._gridContainer.appendChild(this._selectedTargetsGrid.renderer.rootElement);
        return Promise.resolve();
    }

    _getFilterOptions(columnsData, customFields) {
        columnsData = Object.keys(columnsData).map((i) =>
            Object.assign({}, columnsData[i], {id: i, field: i, name: i})
        );
        columnsData = this._getFilterFieldsConfig(Object.values(columnsData));
        const filterOptions = [].concat(Object.values(columnsData), customFields);
        const allowedCustomFieldTypes = ["boolean", "string", "enum", "number", "pathlist"];
        return filterOptions
            .filter((option) => {
                if (
                    option.dataType &&
                    !allowedCustomFieldTypes.includes(option.dataType.toLowerCase())
                ) {
                    return false;
                }
                return true;
            })
            .map((optData) => {
                const options = {
                    dataType: optData.dataType ? optData.dataType.toLowerCase() : undefined,
                };
                return Object.assign({}, optData, options);
            });
    }

    _getFilterFieldsConfig(columnsConfig) {
        const getDataType = (dataType) => {
            const allowedTypes = [
                "string",
                "integer",
                "double",
                "date",
                "time",
                "datetime",
                "boolean",
                "pathlist",
            ];
            if (allowedTypes.includes(dataType)) {
                return dataType;
            }
            switch (dataType) {
                case "number":
                    return "integer";
                default:
                    return "string";
            }
        };

        const generateFilterItem = ({name, label, dataType, options, validation, typeInfo}) => {
            let normalisedDataType = getDataType(dataType);

            const filterItem = {
                id: name,
                field: name,
                name: name,
                dataType: dataType,
                label: label,
                type: normalisedDataType,
                size: 35,
            };

            if (dataType === "enum" && typeInfo && !typeInfo.multiSelect) {
                const {ids = [], labels = []} = typeInfo;
                options = labels.map((label, idx) => ({[ids[idx]]: label}));
            }

            if (!_.isEmpty(validation)) {
                Object.assign(filterItem, {validation: validation});
            }

            if (!_.isEmpty(options)) {
                Object.assign(filterItem, {
                    typeInfo: {
                        ids: Object.keys(options).map((i) => options[i].name),
                        labels: Object.keys(options).map((i) => options[i].title),
                        multiSelect: false,
                    },
                    input: "select",
                    operators: ["equal_select", "not_equal_select", "is_empty", "is_not_empty"],
                });
            }
            if (dataType === "longstring") {
                Object.assign(filterItem, {
                    values: options,
                    input: "text",
                    operators: [
                        "longstring_begins_with",
                        "longstring_not_begins_with",
                        "contains",
                        "not_contains",
                        "longstring_ends_with",
                        "longstring_not_ends_with",
                        "is_empty",
                        "is_not_empty",
                    ],
                });
            }

            if (dataType === "boolean") {
                Object.assign(filterItem, {
                    operators: ["equal", "is_empty", "is_not_empty"],
                    input: "radio",
                    default_value: true,
                    values: {
                        1: "Yes",
                        0: "No",
                    },
                    valueSetter: function (rule, value) {
                        value = Number(value) || 0;
                        const name = rule.id + "_value_0";
                        rule.$el
                            .find("[name=" + name + '][value="' + value + '"]')
                            .prop("checked", true)
                            .trigger("change");
                    },
                });
            }

            if (dataType === "date") {
                Object.assign(
                    filterItem,
                    {
                        operators: [
                            "equal",
                            "less",
                            "less_or_equal",
                            "greater",
                            "greater_or_equal",
                            "is_empty",
                            "is_not_empty",
                        ],
                    },
                    this.generateCalendarInput(name)
                );
            }

            if (dataType === "pathlist") {
                Object.assign(filterItem, {
                    options,
                    input: "select",
                    operators: ["pathlist_equals", "pathlist_not_equals"],
                });
            }

            return filterItem;
        };
        return columnsConfig.map(generateFilterItem);
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onShutdown() {
        this._model._workTriggerDetailsView._renderer._rootElem.classList.remove("devices");
        let shutdowns = [this._selectedTargetsGrid.shutdown()];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._gridContainer.remove();
                this._gridContainer = undefined;
                this._selectedTargetsGrid = undefined;
            })
            .catch((err) => {
                this.model.logger.warn(
                    {error: err},
                    "WorkTriggerTargetsReadonlyTabRenderer.shutdown() error"
                );
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = WorkTriggerTargetsReadonlyTabRenderer;
